import {
  ACCOUNT_DISTRIBUTION_PATH,
  ACCOUNT_REFUND_PATH,
  ACCOUNT_TRANSFER_HISTORY_PATH,
} from 'core/cuenta/routes';
import { MenuItems } from './models/MenuItemsModel';
import { CREATION_USERS_PATH, LIST_USERS_PATH } from 'user/routes';
import { LIST_CARDS_PATH } from 'core/tarjeta/routes';
import { COST_CENTRE_LIST_PATH } from 'core/centrocosto/routes';
import { CONSULTAR_REPORTE_PATH } from 'core/reporte/routes';
import { REPORT_MENU_PERMISSIONS } from 'core/reporte/util/reportPermissions';
import {
  TRANSACTIONS_SUMMARY_PATH,
  TRANSACTIONS_HISTORY_PATH,
} from 'core/movimientos/routes';
import { IMPERSONATION_HOME_PATH } from 'user/routes';

export const MENU_ITEMS: MenuItems = {
  sections: [
    {
      items: [
        {
          icon: 'HomeIcon-1',
          functions: ['PERMITIR'],
          name: 'Inicio',
          path: '/',
        },
      ],
    },
    {
      abbr: 'Login interno',
      name: 'Login interno',
      items: [
        {
          icon: 'UsersIcon',
          functions: ['IMPERSONACION_MENU'],
          name: 'Ingresar como otro usuario',
          path: IMPERSONATION_HOME_PATH,
        },
      ],
    },
    {
      abbr: 'Organización',
      name: 'Organización',
      items: [
        {
          icon: 'PaymentCardIcon',
          functions: ['ABM_TARJETA', 'CONSULTA_TARJETA'],
          name: 'Tarjetas',
          path: LIST_CARDS_PATH,
        },
        {
          icon: 'BankIcon',
          functions: ['ABM_CENTRO_COSTO', 'CONSULTA_CENTRO_COSTO'],
          name: 'Centros de costos',
          path: COST_CENTRE_LIST_PATH,
        },
      ],
    },

    {
      abbr: 'Periodos',
      name: 'Información sobre periodos',
      items: [
        {
          icon: 'bi-cash-stack',
          name: 'Historial de movimientos',
          path: TRANSACTIONS_HISTORY_PATH,
          functions: ['CONSULTA_CUENTA'],
        },
        {
          icon: 'PaymentCardIcon',
          name: 'Totales agrupados',
          path: TRANSACTIONS_SUMMARY_PATH,
          functions: ['CONSULTA_CUENTA'],
        },
      ],
    },
    {
      abbr: 'Transferencias',
      name: 'Distribución y devolución de fondos',
      items: [
        {
          icon: 'MoneyTransferIcon',
          functions: ['DISTRIBUCION'],
          name: 'Realizar distribución',
          path: ACCOUNT_DISTRIBUTION_PATH,
        },
        // {
        //   icon: 'FastForwardIcon',
        //   functions: ['DISTRIBUCION'],
        //   name: 'Realizar transferencia',
        //   path: COST_CENTRE_MASS_DISTRIBUTION_PATH,
        // },
        {
          icon: 'ArrowReturnLeft',
          functions: ['DEVOLUCION_TOTAL', 'DEVOLUCION_PARCIAL'],
          name: 'Realizar devolución',
          path: ACCOUNT_REFUND_PATH,
        },
        {
          icon: 'ListIcon',
          functions: ['CONSULTA_TRANSFERENCIA'],
          name: 'Transferencias realizadas',
          path: ACCOUNT_TRANSFER_HISTORY_PATH,
        },
      ],
    },
    {
      abbr: 'Usuarios',
      name: 'Usuarios',
      items: [
        {
          icon: 'MoneyTransferIcon',
          functions: ['ABM_USUARIO'],
          name: 'Crear usuario',
          path: CREATION_USERS_PATH,
        },
        {
          icon: 'UsersIcon',
          functions: ['ABM_USUARIO'],
          name: 'Listado de Usuarios',
          path: LIST_USERS_PATH,
        },
      ],
    },
    {
      abbr: 'Reportes',
      name: 'Reportes',
      items: [
        {
          icon: 'ClipboardFileIcon',
          functions: [...REPORT_MENU_PERMISSIONS],
          name: 'Reportes',
          path: CONSULTAR_REPORTE_PATH,
        },
      ],
    },
  ],
};
